// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
  position:absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;
}
.actions {
  background-color:black;
  color:white;
  position:absolute;
  top:-40px;
  right:0;
}
.disabled{
    cursor:not-allowed;
}
.layoutitem-edit-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

.layoutitem-edit-overlay-hover {
    background: rgba(0, 0, 0, 0.2);
}

.layoutitem-edit-overlay-selected {
    border: 3px solid green;
}

.layout-item-component-label {
    background: var(--appbuilder-actions-background);
    color: var(--appbuilder-actions-color);
    position: absolute;
    right:0;
    padding: 1px 5px;
    z-index: 999;
    display: flex;
    flex-direction: row;
    height: 30px;
    align-items: center;
    border:0px solid black;
    /*border-bottom-left-radius: 15px;*/
}

.layout-item-component-action{
    height:24px;
    width:24px;
    cursor:pointer;
}
    .layout-item-component-action:hover {
        color: var(--appbuilder-accent-color)
    }
.editmode {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 3px solid var(--appbuilder-primary-color);
    pointer-events: none;
    z-index: 999;
}
.hover {
    background: var(--appbuilder-hover-background);
    border: 3px solid var(--appbuilder-primary-color);
}
.edit-label {
    color: var(--appbuilder-toolbox-background);
    background: var(--appbuilder-toolbox-color);
    border: 0px solid black;
    /*border-bottom-right-radius: 15px;*/
    padding: 5px 8px;
    position: absolute;
    left: 0px;
    top: 0px;
    pointer-events: none;
}
.above {
    bottom: unset;
    top: 0;
    margin-top: -30px;
}
.below{
    bottom:0;
    top:unset;
    margin-bottom:-30px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/layoutitem/layout.item.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,KAAK;EACL,QAAQ;EACR,MAAM;EACN,OAAO;AACT;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,OAAO;AACT;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gDAAgD;IAChD,sCAAsC;IACtC,kBAAkB;IAClB,OAAO;IACP,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,UAAU;IACV,cAAc;AAClB;IACI;QACI;IACJ;AACJ;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iDAAiD;IACjD,oBAAoB;IACpB,YAAY;AAChB;AACA;IACI,8CAA8C;IAC9C,iDAAiD;AACrD;AACA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,uBAAuB;IACvB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,MAAM;IACN,iBAAiB;AACrB;AACA;IACI,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB","sourcesContent":[".overlay {\n  position:absolute;\n  top:0;\n  bottom:0;\n  left:0;\n  right:0;\n}\n.actions {\n  background-color:black;\n  color:white;\n  position:absolute;\n  top:-40px;\n  right:0;\n}\n.disabled{\n    cursor:not-allowed;\n}\n.layoutitem-edit-overlay {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n\n.layoutitem-edit-overlay-hover {\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.layoutitem-edit-overlay-selected {\n    border: 3px solid green;\n}\n\n.layout-item-component-label {\n    background: var(--appbuilder-actions-background);\n    color: var(--appbuilder-actions-color);\n    position: absolute;\n    right:0;\n    padding: 1px 5px;\n    z-index: 999;\n    display: flex;\n    flex-direction: row;\n    height: 30px;\n    align-items: center;\n    border:0px solid black;\n    /*border-bottom-left-radius: 15px;*/\n}\n\n.layout-item-component-action{\n    height:24px;\n    width:24px;\n    cursor:pointer;\n}\n    .layout-item-component-action:hover {\n        color: var(--appbuilder-accent-color)\n    }\n.editmode {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border: 3px solid var(--appbuilder-primary-color);\n    pointer-events: none;\n    z-index: 999;\n}\n.hover {\n    background: var(--appbuilder-hover-background);\n    border: 3px solid var(--appbuilder-primary-color);\n}\n.edit-label {\n    color: var(--appbuilder-toolbox-background);\n    background: var(--appbuilder-toolbox-color);\n    border: 0px solid black;\n    /*border-bottom-right-radius: 15px;*/\n    padding: 5px 8px;\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    pointer-events: none;\n}\n.above {\n    bottom: unset;\n    top: 0;\n    margin-top: -30px;\n}\n.below{\n    bottom:0;\n    top:unset;\n    margin-bottom:-30px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
